import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";
import { toast, ToastContainer } from "react-toastify";

const AiAgentPage = ({ userRole = "user" }) => {
  // Initialize with the first task selected by default for UI
  const [selectedTasks, setSelectedTasks] = useState(["Schedule appointments"]);
  const navigate = useNavigate();
  const [currentPage] = useState(4);

  const tasks = [
    "Schedule appointments",
    "Place automated outbound calls",
    "Gather contact information",
    "Answer frequently asked questions",
    "Integrate with other software",
    "Route & transfer calls",
  ];

  const pages = ["GetStarted", "bussines", "url", "calls", "AiAgentPage"];

  const launchConfetti = () => {
    confetti({
      particleCount: 150,
      spread: 80,
      origin: { y: 0.6 },
    });
  };

  const saveTasks = async (tasks) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.id) {
      toast.error("User not found. Please log in again.");
      navigate("/");
      return false;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/intro-data`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id,
          page: 5,
          data: { aiTasks: tasks },
        }),
      });

      const data = await response.json();
      if (response.ok) {
        console.log("AI Tasks saved:", data.introData);
        return true;
      } else {
        toast.error(data.error || "Failed to save AI tasks.");
        return false;
      }
    } catch (error) {
      console.error("Error saving AI tasks:", error);
      toast.error("An error occurred. Please try again.");
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await saveTasks(selectedTasks);
    if (success) {
      toast.success("AI tasks saved successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      launchConfetti();
      setTimeout(() => navigate("/dashboard"), 2000);
    }
  };

  const handleSkip = async () => {
    // Always send the first task as the default payload on skip
    const defaultTask = [tasks[0]]; // ["Schedule appointments"]
    const success = await saveTasks(defaultTask);
    if (success) {
      // toast.success("Default AI task saved successfully!", {
      //   position: "top-right",
      //   autoClose: 2000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      // });
      launchConfetti();
      setTimeout(() => navigate("/dashboard"), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      <div className="flex flex-col items-center text-center max-w-lg mx-auto w-full">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 w-full">
          Why do you want to use Ryngmo for?
        </h1>
        <p className="text-gray-600 text-base md:text-lg mb-8 w-full">
          Select the tasks you want your AI agent to handle
        </p>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="bg-white rounded-lg shadow-md p-4">
            {tasks.map((task, index) => (
              <label
                key={index}
                className="flex items-center justify-between px-4 py-2 border-b border-gray-200 cursor-pointer"
              >
                <span>{task}</span>
                <input
                  type="checkbox"
                  name="tasks"
                  value={task}
                  checked={selectedTasks.includes(task)}
                  onChange={() => {
                    setSelectedTasks((prev) =>
                      prev.includes(task)
                        ? prev.filter((t) => t !== task)
                        : [...prev, task]
                    );
                  }}
                  className="form-checkbox h-4 w-4 text-blue-600 transition duration-200 ease-in-out"
                />
              </label>
            ))}
          </div>
          <button
            type="submit"
            className="bg-blue-600 text-white font-medium py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors w-full mt-4"
          >
            Continue
          </button>
          <button
            type="button"
            onClick={handleSkip}
            className="bg-gray-200 text-gray-700 font-medium py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-gray-300 transition-colors w-full text-sm sm:text-base mt-2"
          >
            Skip
          </button>
        </form>
      </div>
      <div className="mt-10 flex space-x-2 w-full justify-center">
        {pages.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full ${index === currentPage ? "bg-gray-900" : "bg-gray-300"}`}
          />
        ))}
      </div>
      <ToastContainer />
    </div>
  );
};

export default AiAgentPage;